
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniainchichwad() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Pimpri Chinchwad ',
        heading: 'Amruta Travels: Urbania On Rent in Pimpri Chinchwad',
        headingDescription: 'Amruta Travels offers Urbania on Rent in Pimpri Chinchwad, providing a luxurious and comfortable transportation solution for all your travel needs. Whether you are planning a corporate event, family trip, wedding, or group tour, our well-maintained Force Urbania vans ensure a smooth and enjoyable journey.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


   "services": [
    {
      "name": "Urbania on Rent in Pimpri Chinchwad Contact Number",
      "description": "For reliable Force Urbania rentals in Pimpri Chinchwad, contact Amruta Travels. We offer flexible rental plans for local and outstation travel, with well-maintained vehicles and professional drivers to ensure a smooth ride."
    },
    {
      "name": "Urbania on Rent in Bhosari",
      "description": "Amruta Travels provides Force Urbania rentals in Bhosari, Pune, for group travel, corporate events, family outings, and more. Our 13-seater and 17-seater options offer maximum comfort, AC, and spacious interiors, ideal for long journeys."
    },
    {
      "name": "Force Urbania for Rent in Pune",
      "description": "Amruta Travels offers the Force Urbania for rent across Pune, perfect for family trips, corporate outings, and school picnics. With professional drivers and comfortable interiors, our Urbania vehicles guarantee a premium travel experience."
    },
    {
      "name": "Urbania on Rent in Hinjewadi",
      "description": "Book an Urbania on rent in Hinjewadi, Pune, with Amruta Travels for your next corporate event, city tour, or group outing. Our 13- and 17-seater vans are fully equipped with AC and comfortable seating, ensuring a pleasant journey."
    },
    {
      "name": "Force Urbania 17 Seater for Rent in Baner",
      "description": "Rent a Force Urbania 17-seater in Baner, Pune, with Amruta Travels. Whether for corporate transport, family outings, or sightseeing, our vans are designed for comfort and convenience with spacious interiors, air conditioning, and experienced drivers."
    },
    {
      "name": "Force Urbania 17 Seater for Rent in Aundh",
      "description": "Amruta Travels offers 17-seater Force Urbania rentals in Aundh for business trips, school tours, or family trips. Our well-maintained vehicles provide a premium experience with AC comfort and ample luggage space."
    },
    {
      "name": "Force Urbania on Rent in Pune",
      "description": "Need a Force Urbania on rent in Pune? Amruta Travels offers affordable and luxurious Urbania vehicles for local travel, outstation trips, and corporate needs. Enjoy a smooth ride with AC, pushback seats, and more."
    },
    {
      "name": "Force Urbania on Rent in Kothrud",
      "description": "Book Force Urbania rentals in Kothrud, Pune, with Amruta Travels. Our 13- and 17-seater vans are perfect for short trips, office outings, and group events. Get ready for a comfortable journey with our professional drivers and top-notch amenities."
    },
    {
      "name": "Force Urbania for Rent in Shivaji Nagar Pune",
      "description": "Amruta Travels provides reliable Force Urbania rentals in Shivaji Nagar, Pune. Whether you need a vehicle for a corporate outing, family gathering, or city tour, our Urbania vans are equipped for comfort, safety, and convenience."
    },
    {
      "name": "Urbania On Rent in Pimpri Chinchwad with Amruta Travels",
      "description": "For Urbania rentals in Pimpri Chinchwad, Amruta Travels offers 13-seater and 17-seater options suitable for both short trips and long-distance travel. Our vans are well-maintained, equipped with AC, and driven by experienced chauffeurs."
    },
    {
      "name": "Luxury Force Urbania On Rent in Chinchwad",
      "description": "Looking for a luxurious ride? Amruta Travels offers luxury Force Urbania rentals in Chinchwad, Pune. These vans are ideal for high-end corporate transport, special events, and family celebrations, providing premium comfort and style."
    },
    {
      "name": "Force Urbania for Rent in Pune Nashik Phata",
      "description": "Amruta Travels offers Force Urbania vans for rent in the Nashik Phata area. Perfect for long-distance trips, office transport, or school outings, our 13- and 17-seater vehicles are comfortable, clean, and ready to go wherever you need."
    },
    {
      "name": "Urbania on Rent in Akurdi Pune",
      "description": "Rent a Force Urbania in Akurdi with Amruta Travels for city tours, family trips, or corporate outings. Our vans offer spacious seating, air conditioning, and a reliable chauffeur service for all your travel needs in and around Pune."
    },
    {
      "name": "Urbania On Rent in PCMC Area",
      "description": "Amruta Travels offers Force Urbania rentals in the PCMC area of Pune. Whether you need transport for corporate trips, family events, or school excursions, our 13- and 17-seater Urbania vehicles ensure a smooth and comfortable journey."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Pimpri Chinchwad Contact Number", "Urbania on Rent in Bhosari"],
    ["Force Urbania for Rent in Pune", "Urbania on Rent in Hinjewadi"],
    ["Force Urbania 17 Seater for Rent in Baner", "Force Urbania 17 Seater for Rent in Aundh"],
    ["Force Urbania on Rent in Pune", "Force Urbania on Rent in Kothrud"],
    ["Force Urbania for Rent in Shivaji Nagar Pune", "Urbania On Rent in Pimpri Chinchwad with Amruta Travels"],
    ["Luxury Force Urbania On Rent in Chinchwad", "Force Urbania for Rent in Pune Nashik Phata"],
    ["Urbania on Rent in Akurdi Pune", "Urbania On Rent in PCMC Area"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Convenient Urbania Van Rentals in Pimpri Chinchwad",
    "WhyChoosedescription": "Amruta Travels offers premium Urbania vans for rent in Pimpri Chinchwad, perfect for group travel, corporate events, or family outings. With spacious interiors and modern features, our Urbania vans are the ideal choice for comfortable, reliable, and stylish travel within Pimpri Chinchwad and beyond."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Travel for Groups",
    "WhyChoosedescription": "Our Urbania vans are designed to provide maximum comfort with plush seating, ample legroom, and air conditioning. Whether you're traveling for a corporate meeting, family function, or group outing, the spacious interiors of the Urbania vans ensure a smooth and relaxing journey."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and Event Travel in Pimpri Chinchwad",
    "WhyChoosedescription": "Urbania vans are ideal for corporate transport, family trips, weddings, and event transportation in Pimpri Chinchwad. They are equipped to handle a variety of group sizes, providing a premium travel experience for short local trips or longer journeys to nearby destinations."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Urbania Rentals",
    "WhyChoosedescription": "Amruta Travels offers affordable and transparent pricing for Urbania van rentals in Pimpri Chinchwad. Our all-inclusive pricing covers fuel, tolls, driver fees, and taxes, so you won’t face any hidden charges. You can book confidently while staying within your travel budget."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers in Pimpri Chinchwad",
    "WhyChoosedescription": "Our trained and experienced drivers ensure safe, punctual, and smooth rides for all Urbania van rentals. They are familiar with Pimpri Chinchwad’s routes and the best paths for outstation trips, guaranteeing a stress-free and comfortable experience for all passengers."
  },
  {
    "WhyChooseheading": "Ideal for Both Local and Outstation Trips",
    "WhyChoosedescription": "Whether you're planning a local trip within Pimpri Chinchwad or a long-distance journey to places like Lonavala, Shirdi, or Goa, Urbania vans provide superior ride quality. The spacious interiors and modern amenities ensure that your group travels in comfort and style."
  },
  {
    "WhyChooseheading": "Hassle-Free Online Booking for Urbania Rentals",
    "WhyChoosedescription": "Booking an Urbania van in Pimpri Chinchwad is simple and quick with Amruta Travels. Our online booking platform makes it easy to select the vehicle, schedule the rental, and receive instant confirmation. We also offer flexible booking durations, from hourly to multi-day rentals."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Urbania Rental Queries",
    "WhyChoosedescription": "Our dedicated customer support team is available 24/7 to assist with bookings, itinerary changes, or any other queries related to Urbania van rentals in Pimpri Chinchwad. We’re here to ensure your rental experience is smooth and convenient from start to finish."
  }
]




















    }

const faqData = [
  {
    question: 'Can I rent a Force Urbania in Pimpri Chinchwad with Amruta Travels?',
    answer: 'Yes, Amruta Travels provides Force Urbania rentals in Pimpri Chinchwad. Whether for local travel, outstation trips, or events, our Urbania minibuses are ideal for safe and comfortable group transportation.',
  },
  {
    question: 'What seating options are available for Force Urbania rentals in Pimpri Chinchwad?',
    answer: 'We offer Force Urbania vehicles in 13-seater and 17-seater variants, making them perfect for small to medium-sized groups traveling from Pimpri Chinchwad.',
  },
  {
    question: 'Is a driver included when I rent a Force Urbania in Pimpri Chinchwad?',
    answer: 'Yes, all Urbania rentals come with a professional, experienced driver to ensure a safe, stress-free journey.',
  },
  {
    question: 'Can I book a Force Urbania for local and outstation trips from Pimpri Chinchwad?',
    answer: 'Absolutely! You can rent a Force Urbania for both local travel within Pimpri Chinchwad and long-distance trips to destinations like Mumbai, Shirdi, Mahabaleshwar, and Goa.',
  },
  {
    question: 'Are Urbania vehicles available for corporate or family events in Pimpri Chinchwad?',
    answer: 'Yes, our Force Urbania rentals are popular for corporate events, weddings, family outings, and group tours in and around Pimpri Chinchwad.',
  },
  {
    question: 'How much does it cost to rent a Force Urbania in Pimpri Chinchwad?',
    answer: 'The cost depends on the seating capacity, travel distance, and duration. Rates typically start from ₹35/km for a 13-seater and ₹38/km for a 17-seater, with local packages also available.',
  },
  {
    question: 'Are the Urbania minibuses sanitized and well-maintained?',
    answer: 'Yes, all our Force Urbania vehicles undergo routine maintenance and are thoroughly sanitized before each trip to meet high standards of safety and cleanliness.',
  },
  {
    question: 'How can I book a Force Urbania in Pimpri Chinchwad?',
    answer: 'You can easily book through our website or by contacting our team. Just share your travel details, and we’ll help you reserve the right Urbania for your journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ajay Bhosale',
    role: 'Small Business Owner, Pimpri',
    text: 'I rented a 13-seater Force Urbania from Pimpri for a business event. The vehicle was clean, punctual, and comfortable. The driver was courteous and professional. Great service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Rutuja Patil',
    role: 'Homemaker, Chinchwad',
    text: 'We hired an Urbania for a family trip to Lonavala from Chinchwad. It was spacious, neat, and very comfortable. Booking was easy and the experience was excellent!',
    rating: 5,
  },
];











































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pimpri Chinchwad",
  "image": "https://bushireinpune.com/assets/images/urbania-on-rent-pimpri-chinchwad.jpg", // Update with the actual image URL
  "description": "Amruta Travels offers Force Urbania on rent in Pimpri Chinchwad for corporate events, employee outings, family trips, and more. Rent luxury 13-seater and 17-seater Urbania buses for your travel needs in Pimpri Chinchwad, Pune. Affordable rentals available for local and outstation trips.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500", // Adjust the price as per service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-on-rent-pimpri-chinchwad"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania On Rent in Pimpri Chinchwad | Luxury Mini Bus Rental | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent Force Urbania 13-seater and 17-seater mini buses in Pimpri Chinchwad for corporate events, family trips, employee outings, and more. Affordable rentals available for local and outstation trips in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniainchichwad;